import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  fetchWeekTemplates,
  createWeekTemplate,
  updateWeekTemplate,
  deleteWeekTemplate,
  duplicateWeekTemplate,
  type WeekTemplateCreate,
  type WeekTemplateUpdate,
} from '@/lib/templateApi';

const QUERY_KEY = ['weekTemplates'] as const;

export function useWeekTemplates(params?: { sport?: string; search?: string }) {
  return useQuery({
    queryKey: [...QUERY_KEY, params],
    queryFn: () => fetchWeekTemplates(params),
  });
}

export function useCreateWeekTemplate() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (payload: WeekTemplateCreate) => createWeekTemplate(payload),
    onSuccess: () => qc.invalidateQueries({ queryKey: QUERY_KEY }),
  });
}

export function useUpdateWeekTemplate() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, payload }: { id: string; payload: WeekTemplateUpdate }) =>
      updateWeekTemplate(id, payload),
    onSuccess: () => qc.invalidateQueries({ queryKey: QUERY_KEY }),
  });
}

export function useDeleteWeekTemplate() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => deleteWeekTemplate(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: QUERY_KEY }),
  });
}

export function useDuplicateWeekTemplate() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => duplicateWeekTemplate(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: QUERY_KEY }),
  });
}
